import { defineMessages } from "react-intl";

export const sortOptionsMessages = defineMessages({
  completedAt: {
    id: "activities.list.filterBar.quickSort.completedAt",
    defaultMessage: "Date done",
    description: "activities done At quicksort filter",
  },
  createdAt: {
    id: "activities.list.filterBar.quickSort.createdAt",
    defaultMessage: "Date created",
    description: "activities created At quicksort filter",
  },
  dueDate: {
    id: "activities.list.filterBar.quickSort.dueDate",
    defaultMessage: "Due date",
    description: "activities due Date quicksort filter",
  },
  startAt: {
    id: "activities.list.filterBar.quickSort.startAt",
    defaultMessage: "Date of activity",
    description: "activities start At quicksort filter",
  },
  updatedAt: {
    id: "activities.list.filterBar.quickSort.updatedAt",
    defaultMessage: "Date modified",
    description: "activities updated At quicksort filter",
  },
});
